var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 24.5 9.5-9.4c.7-.7.7-1.8 0-2.5l-.4-.4c-.7-.7-1.8-.7-2.5 0L18 16.9V3.2c0-1.1-.9-2-2-2h-.1c-1.1 0-2 .9-2 2v13.7l-4.6-4.6c-.7-.7-1.8-.7-2.5 0l-.4.3c-.7.7-.7 1.8 0 2.5zm10.5 2.6h-21c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8h21.1c1 0 1.8-.8 1.8-1.8s-.9-1.8-1.9-1.8"
  })));
};
export default SvgDownload;